import { render, staticRenderFns } from "./SpecialFeaturesPicker.vue?vue&type=template&id=c9b70e6a&"
import script from "./SpecialFeaturesPicker.vue?vue&type=script&lang=ts&"
export * from "./SpecialFeaturesPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports